/**
 * @(#)2019/6/10.
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { cloneElement } from "react";
import ReactDOM from "react-dom";
import Utils, { cloneDeep, merge, yxTextNumProps } from "../../../utils";
import Basics from "../Basics";
import { YxComponent, Connection } from "../../YxComponent";

//默认props
let defaul = () => {
  return {
    type: "int", //int/float/amount
    amountType: "RMB", //金额类型
    isShowSymbolBefore: true, //是否显示金额前面的内容，比如 ￥,只有指定金额类型才会显示,可以选择不显示
    isShowSymbolAfter: true, //是否显示金额后面的内容，比如 ￥,只有指定金额类型才会显示,可以选择不显示
    beforeStrClass: "", //前置内容的样式
    afterStrClass: "", //后置内容的样式
    precision: 0, //保留几位小数
    isRounding: true, //是否开启四舍五入
    isThousand: true, //是否开启千分位处理
    amountTypeExtra: {}, //金额类型列表 示例：{ "RMB",{moneySymbol:'￥', moneyCompany:'元'},... }
  };
};
/*
 * Number，展示数字或金额的组件
 * -----------------------公共部分参数--------------------------------------------------
 * @param children {number} 子节点，需要展示的内容
 * @param type {enum} 类型，int/float/amount
 * @param precision {number} 保留几位小数，默认0
 * @param isRounding {bool} 是否开启四舍五入，默认开启，在处理千分位和小数点时有效
 * @param isThousand {bool} 是否开启千分位处理，默认true
 *-----------------------金额部分参数-------------------------------------------
 * @param amountType {enum} 金额类型，开启后，自动添加单位和金钱符号，
 *         RMB（自动添加￥ 元），USD（$ dollar）,GBP（￡ pound）EUR（€ euro），默认 false
 * @param isShowSymbolBefore {bool} 是否显示金额前面的内容,在指定金额类型的情况下， 默认显示，可以选择隐藏
 * @param isShowSymbolAfter {bool} 是否显示金额后面的内容,在指定金额类型的情况下， 默认显示，可以选择隐藏
 * */
@Connection(defaul)
export default class Number extends YxComponent {
  //默认参数
  static defaultProps = {
    children: "", //子节点
    ...defaul,
  };

  constructor(props) {
    super(props);
    this.state = {
      amountTypeStr: merge(
        {
          RMB: {
            moneySymbol: "￥",
            moneyCompany: "元",
          },
          USD: {
            moneySymbol: "$",
            moneyCompany: "dollar",
          },
          GBP: {
            moneySymbol: "￡",
            moneyCompany: "pound",
          },
          EUR: {
            moneySymbol: "€",
            moneyCompany: "euro",
          },
        },
        this.props.amountTypeExtra
      ),
    };
  }

  //处理字符串
  Handle(s) {
    let str = s || "0";
    let props = this.props;
    let precision; //小数长度
    //如果开启了非四舍五入，一律给小数长度加2，然后在下面再截掉
    if (!props.isRounding) {
      precision = props.precision + 2;
    } else {
      precision = props.precision;
    }

    //设置千分位
    if ((props.type == "amount" && props.isThousand) || props.isThousand) {
      str = Utils.numberFormat({ number: str, precision: precision });
    } else {
      //不开启千分位的情况下，保留几位小数
      str = parseFloat(str).toFixed(parseInt(precision));
    }

    //截掉多余的
    if (!props.isRounding) {
      str = String(str);
      //如果要求保留的小数点为0，那么就要多截一个小数点
      str =
        props.precision == 0
          ? str.substring(0, str.length - 3)
          : str.substring(0, str.length - 2);
    }

    if (props.type == "amount") {
      let amountTypeStr = this.state.amountTypeStr;

      //如果不显示金额前面的内容
      if (!props.isShowSymbolBefore) {
        amountTypeStr[props.amountType].moneySymbol = "";
      }
      //如果不显示金额后面的内容
      if (!props.isShowSymbolAfter) {
        amountTypeStr[props.amountType].moneyCompany = "";
      }

      str = (
        <span>
          <span className={props.beforeStrClass}>
            {amountTypeStr[props.amountType].moneySymbol}
          </span>
          {str}
        </span>
      );
      //放置字符串后置内容
      str = (
        <span>
          {str}
          <span className={props.afterStrClass}>
            {amountTypeStr[props.amountType].moneyCompany}
          </span>
        </span>
      );
    }

    return str;
  }

  renderHtml = (props) => {
    let tmpProps = cloneDeep(props);
    let childrenType = typeof tmpProps.children;
    if (childrenType == "string" || childrenType == "number") {
      tmpProps.children = this.Handle(tmpProps.children);
    } else if (
      Object.prototype.toString.call(tmpProps.children) === "[object Array]"
    ) {
      return tmpProps.children.map((val, index) => {
        return this.renderHtml({
          key: index,
          ...tmpProps,
          children: val.children || val,
        });
      });
    }
    let html = Basics.html(yxTextNumProps(tmpProps));
    return html;
  };

  render() {
    let tmpProps = this.props;
    return this.renderHtml(tmpProps);
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Number/Number.js